import React, { useState, useEffect } from 'react';
import Axios from 'axios';

import * as Antd from 'antd';
import * as AntdIcons from '@ant-design/icons';
import * as SYS from './';

export const DatasetsGrid = props => {
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState([]);
    const [datasetFormInit, setDatasetFormInit] = useState(null);

    const fetchData = async () => {
        try {
            let dataResponse = await Axios.get(`${process.env.REACT_APP_API_BASE_URI}/api/datasets`, {
                params: {
                    filter: {
                        order: 'code ASC'
                    }
                }
            });
            return dataResponse.data;
        } catch (err) {
            console.log(err);
        }
    }

    const init = async () => {
        setLoading(true);
        let d = await fetchData();
        setData(d);
        setLoading(false);
    }

    useEffect(() => {
        init();
    }, []);

    const onFormSuccess = async (values) => {
        try {
            if (values.id) {
                let id = values.id;
                delete values.id;
                await Axios.patch(`${process.env.REACT_APP_API_BASE_URI}/api/datasets/${id}`, values);
            } else {
                await Axios.post(`${process.env.REACT_APP_API_BASE_URI}/api/datasets`, values);
            }
            await init();
        } catch (err) {
            console.log(err);
        }
    }

    const onDeleteItem = async (id) => {
        try {
            await Axios.delete(`${process.env.REACT_APP_API_BASE_URI}/api/datasets/${id}`);
            await init();
        } catch (err) {
            console.log(err);
        }
    }

    return (
        <>
            <Antd.Space
                style={{
                    marginBottom: 10,
                    float: 'right',
                }}
            >
                <Antd.Button
                    icon={<AntdIcons.ReloadOutlined />}
                    title="Reload"
                    disabled={loading}
                    onClick={() => {
                        init();
                    }}
                />
                <Antd.Button
                    icon={<AntdIcons.PlusOutlined />}
                    title="Create new"
                    disabled={loading}
                    onClick={() => {
                        setDatasetFormInit({});
                    }}
                />
            </Antd.Space>
            <Antd.Table
                className="table-striped-rows table-small"
                size={'small'}
                loading={loading}
                dataSource={data}
                rowKey={'id'}
                pagination={{
                    defaultPageSize: 50,                    
                    showSizeChanger: true,
                }}
            >
                <Antd.Table.Column
                    key='code'
                    dataIndex='code'
                    title='Code'
                    width={250}
                />
                <Antd.Table.Column
                    key='name'
                    dataIndex='name'
                    title='Name'
                />
                <Antd.Table.Column
                    key='type'
                    dataIndex='type'
                    title='Type'
                />
                <Antd.Table.Column
                    key='action'
                    title='Action'
                    width={200}
                    render={(value, record) => (
                        <Antd.Space
                            size="middle"
                        >
                            <a
                                onClick={() => {
                                    for (let columnIdx in record.columns) {
                                        if (record.columns[columnIdx].settings.datagrid.render) {
                                            record.columns[columnIdx].settings.datagrid.decodedRender = atob(record.columns[columnIdx].settings.datagrid.render);
                                        }
                                    }
                                    setDatasetFormInit(record);
                                }}
                            >
                                Edit
                            </a>
                            <a
                                onClick={() => {
                                    delete record.id;
                                    record.code = record.code + 'Copy';
                                    record.name = record.name + ' - copy';
                                    onFormSuccess(record);
                                }}
                            >
                                Copy
                            </a>
                            <Antd.Popconfirm
                                placement="topLeft"
                                title="Do you really want to delete the entry?"
                                okText="Yes"
                                cancelText="No"
                                onConfirm={() => {
                                    onDeleteItem(record.id);
                                }}
                            >
                                <a>
                                    Delete
                                </a>
                            </Antd.Popconfirm>
                        </Antd.Space>
                    )}
                />
            </Antd.Table>
            <Antd.Drawer
                title={datasetFormInit && datasetFormInit.id
                    ? 'Edit dataset'
                    : 'Create new dataset'}
                width={'85%'}
                visible={datasetFormInit !== null
                    ? true
                    : false}
                closable={true}
                onClose={() => setDatasetFormInit(null)}
            >
                {datasetFormInit
                    ? <SYS.DatasetForm
                        initialValues={datasetFormInit}
                        onSuccess={onFormSuccess}
                    />
                    : null}
            </Antd.Drawer>
        </>
    )
}